<template>
    <div class="form-box">
        <div class="form-title">
            <div class="title-reg">帐号登录</div>
            <div class="title-pass" @click="sendLogin">
                没有帐号 <span>点击注册</span>
            </div>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="mobile">
                <div class="input-div">
                    <img class="input-icon" src="../assets/down-phone.png" alt="" />
                    <el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="userPassword" v-if="codeLogin">
                <div class="input-div">
                    <img class="input-icon newCode" src="../assets/login-code.png" alt="" />
                    <el-input v-model="ruleForm.userPassword" type="password" placeholder="请输入登录密码"></el-input>
                </div>
            </el-form-item>
            <!-- <el-form-item v-if="codeLogin">
                <div class="input-div newInput" @click="captchaImg">
                    <img
                        class="input-icon newPass"
                        src="../assets/login-pass.png"
                        alt=""
                    />
                    <span>请点击完成校验</span>
                </div>
            </el-form-item> -->
            <el-form-item prop="sms" v-else>
                <div class="input-div">
                    <img class="input-icon newCode" src="../assets/login-code.png" alt="" />
                    <el-input v-model="ruleForm.sms" placeholder="请输入验证码">
                        <template slot="append">
                            <div @click="sendsms" v-if="setTime">
                                发送验证码
                            </div>
                            <div v-else>{{ timeNum }}</div>
                        </template></el-input>
                </div>
            </el-form-item>
            <div class="code-login" v-if="codeLogin">
                <span @click="tabLogin">验证码登录</span>
            </div>
            <div class="code-login" v-else>
                <span @click="tabLogin">密码登录</span>
            </div>
            <el-form-item>
                <div class="but-div">
                    <el-button type="primary" class="submitBut" @click="submitForm('ruleForm')">登录</el-button>
                </div>
            </el-form-item>
        </el-form>
        <el-dialog title="请完成安全验证" :visible.sync="dialogVisible" width="25%">
            <div class="code-dia">
                <img :src="'data:image/png;base64,' + codeImg" alt="" @load="getdebrisImageWidth"
                    :style="{ left: `${sliderPosition}px` }" class="code-style newCode" />
                <img :src="'data:image/png;base64,' + codeBack" alt="" @load="getImageWidth" class="code-style" />
                <div class="slider-box">
                    <div class="slider" :style="{ left: `${sliderPosition}px` }" @mousedown="startSliding">
                    </div>
                    <span>向右拖动滑块填充图片</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    loginApi,
    captchaApi,
    sendsmsApi,
    telloginsmsApi,
} from "../api/api.js";
import { MD5 } from "crypto-js";
export default {
    name: "",
    props: ["sendData"],
    data() {
        var checkMobile = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            } else {
                const phoneRegex = /^1[3-9]\d{9}$/;
                if (phoneRegex.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入正确的手机号"));
                }
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                callback();
            }
        };
        return {
            codeLogin: true,
            dialogVisible: false,
            sliderWidth: 260, // 滑块移动的宽度
            sliderPosition: 0, // 当前滑块位置
            codeBack: "",
            debrisWidth: null,

            codeImg: "",
            token: "",

            timeNum: 60,
            setTime: true,

            ruleForm: {
                mobile: "",
                sms: "",
                userPassword: "",
            },
            rules: {
                mobile: [
                    {
                        validator: checkMobile,
                        trigger: "blur",
                    },
                ],
                sms: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                ],
                userPassword: [
                    {
                        validator: validatePass,
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {},
    methods: {
        tabLogin() {
            this.codeLogin = !this.codeLogin;
            this.userPassword = "";
        },
        sendLogin() {
            this.sendData(false);
        },
        startSliding(event) {
            // this.isSliding = true;
            const offsetX = event.clientX - this.sliderPosition;

            const onMouseMove = (e) => {
                // if (this.isSliding) {
                this.sliderPosition = e.clientX - offsetX;

                // 限制滑块位置在合法范围内
                if (this.sliderPosition < 0) this.sliderPosition = 0;
                if (this.sliderPosition > this.sliderWidth)
                    this.sliderPosition = this.sliderWidth;
                // }
            };

            const onMouseUp = async (e) => {
                // this.isSliding = false;
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);

                const newPass = MD5(this.ruleForm.userPassword).toString();
                const res = await loginApi({
                    ...this.ruleForm,
                    userPassword: newPass,
                    captchaVO: {
                        pointJson: `{'x':${this.sliderPosition},'y':5}`,
                        captchaType: "blockPuzzles",
                        token: this.token,
                    },
                });

                if (res?.data?.resp_code == 0) {

                    localStorage.setItem("token", res.data.data.token);
                    this.$store.commit("SET_TOKEN", res.data.data.token);
                    this.$store.commit("SET_USERINFO", res.data.data);
                    this.$message({
                        message: "登录成功",
                        type: "success",
                    });
                    this.$router.push("/");
                    this.dialogVisible = false;
                } else {
                    this.captchaImg();
                }
                this.sliderPosition = 0; // 重置滑块
            };

            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
        },
        getImageWidth(event) {
            this.imageWidth = event.target.naturalWidth;
        },
        getdebrisImageWidth(event) {
            this.debrisWidth = event.target.naturalWidth;
            console.log(this.debrisWidth, "debrisWidth");
        },
        async captchaImg() {
            this.dialogVisible = true;
            const { data } = await captchaApi({
                captchaType: "blockPuzzles",
            });
            if (data.repCode == "0000") {
                this.codeImg = data.repData.jigsawImageBase64;
                this.codeBack = data.repData.originalImageBase64;
                this.token = data.repData.token;
            } else {
                Message.error(data.repMsg);
            }
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (this.codeLogin) {
                        this.captchaImg();
                    } else {
                        this.login();
                    }
                } else {
                    // console.log("error submit!!");
                    return false;
                }
            });
        },
        async sendsms() {
            this.countdown();
            const res = await sendsmsApi({
                mobile: this.ruleForm.mobile,
            });
        },
        // 更新倒计时的函数
        countdown() {
            this.setTime = false;

            // 每秒更新一次倒计时
            this.timer = setInterval(() => {
                this.timeNum = this.timeNum - 1;

                // 当倒计时结束时清除定时器
                if (this.timeNum <= 0) {
                    clearInterval(this.timer);
                    this.setTime = true; // 允许重新开始
                }
            }, 1000); // 每1000毫秒（1秒）执行一次
        },
        async login() {
            const res = await telloginsmsApi(this.ruleForm);
            this.$store.commit("SET_USERINFO", res.data.data);
            localStorage.setItem("token", res.data.data.token);
            this.$store.commit("SET_TOKEN", res.data.data.token);
            // localStorage.setItem("userInfo", JSON.stringify(res.data.data));
            this.$message({
                message: "登录成功",
                type: "success",
            });
            this.$router.push("/");
        },
    },
};
</script>
<style lang="scss" scoped>
.form-box {
    margin: 40px;

    .form-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title-reg {
            font-size: 26px;
            color: #fff;
            font-weight: bold;
        }

        .title-pass {
            font-size: 16px;
            color: #938e8e;

            span {
                color: #ff9000;
                cursor: pointer;
            }
        }
    }

    .demo-ruleForm {
        margin-top: 50px;
    }

    .but-div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
    }

    .submitBut {
        background: #ff9000;
        border: 1px solid #ff9000;
        color: #000;
        font-size: 18px;
        font-weight: bold;
        width: 215px;
    }

    .input-div {
        display: flex;
        align-items: center;

        .input-icon {
            width: 30px;
            height: 43px;
            position: absolute;
            left: 10px;
            /* 根据需要调整 */
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            /* 确保图标在输入框上方 */
        }

        .newCode {
            // width: 27px;
            // height: 31px;
        }

        .newPass {
            width: 25px;
            height: 33px;
        }
    }

    .newInput {
        background: #474545;
        padding: 10px 0;
        padding-left: 60px;
        color: #fff;
        border-radius: 3px;
        cursor: pointer;
    }

    .code-login {
        text-align: right;
        color: #938e8e;
        font-size: 16px;

        span {
            cursor: pointer;
        }
    }
}

.code-style {
    // height: 150px;
}

.newCode {
    position: absolute;
}

.code-dia {
    position: relative;
}

.slider-box {
    border: 1px solid #ccc;
    width: 300px;
    height: 40px;
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
}

.slider {
    position: absolute;
    width: 40px;
    /* 滑块的宽度 */
    height: 40px;
    // background-color: #4caf50;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #ccc;
    cursor: pointer;
    user-select: none;
    /* 禁止用户选择文本 */
}

::v-deep .el-input__inner {
    background: #474545;
    border: 1px solid #474545;
    color: #fff;
    padding: 30px 0;
    padding-left: 60px;
    height: 50px;
}

::v-deep .el-input-group__append {
    background: #474545;
    border: 1px solid #474545;
    cursor: pointer;
    color: #fff;
}
</style>
